import { useToken } from '@chakra-ui/react';

export const useChartDefaultColorList = () => {
  return useToken('colors', [
    'pink-500',
    'bg-buttonHover',
    'vaults-month6',
    'vaults-month12',
    'vaults-month24',
    'vaults-month48',
    'garden-dark',
  ]);
};
